import React from "react";
import styles from './person.module.scss';

const PersonView = ({person}) => {
    
    return (
        <div>
            <table className={styles.practitionerTableView}>
                <tbody>
                    <tr key='1' >
                        <td className={styles.tableColumn}>
                            <h3>Id:</h3>
                        </td>
                        <td className={styles.tableColumn}>
                            <p>{person.resource.id.value}</p>
                        </td> 
                    </tr>
                    <tr key='2' >
                        <td className={styles.tableColumn}>
                            <h3>Managing Organization:</h3>
                        </td>
                        <td className={styles.tableColumn}>
                            <p>{person.resource.managingOrganization.reference.value }</p>
                        </td>
                    </tr>
                    <tr key='3' >
                        <td className={styles.tableColumn}>
                            <h3>Gender:</h3>
                        </td>
                        <td className={styles.tableColumn}>
                            <p>{person.resource.gender.value}</p>
                        </td>
                    </tr>
                    <tr key='4' >
                        <td className={styles.tableColumn}>
                            <h3>Birth Date:</h3>
                        </td>
                        <td className={styles.tableColumn}>
                            <p>{new Date(person.resource.birthDate.value).toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" })}</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default PersonView;